import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import {
  ShiftApplyParam,
  ShiftApplySearchParam,
  ShiftApplySearchResult,
  ShiftApplySingleSearchParam,
  ShiftApplySingleSearchResult,
} from '../../models/gen/models';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const SHIFT_APPLY_CONTEXT_NAMES = {
  POST_SHIFT_APPLY: 'saveShiftApply',
  POST_SHIFT_APPLY_SINGLE_SEARCH: 'searchSingleShiftApply',
} as const;

const apis = apiGenerator();

/**
 * POST /shift-apply
 *
 * @param param -
 * @returns
 */
export const usePostShiftApply = () =>
  useGenericMutation(async (param: ShiftApplyParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/shift-apply`, {
      ...queryOptions,
      data: param,
    })
  );

/**
 * POST /shift-apply/search
 *
 * @param param -
 * @returns
 */
export const usePostShiftApplySearch = () =>
  useGenericMutation(async (param: ShiftApplySingleSearchParam) =>
    apis.post<ShiftApplySingleSearchParam, ShiftApplySingleSearchResult>(
      `${env.BASE_API_ENDPOINT}/shift-apply/single-search`,
      { ...queryOptions, data: param }
    )
  );
